// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NH4tM","icon":"styles_icon__2qkkQ"};